// src/components/admin/SpoiledPhrasesManager.js
import React, {useState, useEffect} from 'react';
import {electionApi} from '../../api/election';
import {TrashIcon, PencilIcon} from '@heroicons/react/24/outline';

const SpoiledPhrasesManager = ({auth}) => {
    const [phrases, setPhrases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newText, setNewText] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editText, setEditText] = useState('');

    const loadPhrases = async () => {
        try {
            const res = await electionApi.getSpoiledPhrases({auth});
            setPhrases(res.data);
        } catch (err) {
            alert('Ошибка загрузки фраз');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadPhrases();
    }, []);

    const handleAdd = async () => {
        if (!newText.trim()) return;
        try {
            await electionApi.createSpoiledPhrase(newText.trim(), {auth});
            setNewText('');
            loadPhrases();
        } catch (err) {
            alert('Ошибка добавления');
        }
    };

    const handleUpdate = async (id) => {
        if (!editText.trim()) return;
        try {
            await electionApi.updateSpoiledPhrase(id, editText.trim(), {auth});
            setEditingId(null);
            loadPhrases();
        } catch (err) {
            alert('Ошибка обновления');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Удалить фразу?')) return;
        try {
            await electionApi.deleteSpoiledPhrase(id, {auth});
            loadPhrases();
        } catch (err) {
            alert('Ошибка удаления');
        }
    };

    if (loading) return <div>Загрузка...</div>;

    return (
        <div className="bg-white p-6 rounded-lg shadow mb-8">
            <h2 className="text-2xl mb-4">Испорченный бюллетень — фразы</h2>
            <div className="flex gap-2 mb-4">
                <input
                    type="text"
                    value={newText}
                    onChange={(e) => setNewText(e.target.value)}
                    placeholder="Новая фраза"
                    className="flex-1 p-2 border rounded"
                />
                <button onClick={handleAdd} className="bg-gold-accent text-white px-4 py-2 rounded hover:bg-yellow-600">
                    Добавить
                </button>
            </div>
            <ul className="space-y-2">
                {phrases.map((p) => (
                    <li key={p.id} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                        {editingId === p.id ? (
                            <div className="flex-1 flex gap-2">
                                <input
                                    type="text"
                                    value={editText}
                                    onChange={(e) => setEditText(e.target.value)}
                                    className="flex-1 p-1 border rounded"
                                />
                                <button onClick={() => handleUpdate(p.id)} className="text-green-600">✓</button>
                                <button onClick={() => setEditingId(null)} className="text-gray-600">✕</button>
                            </div>
                        ) : (
                            <>
                                <span className="flex-1">{p.text}</span>
                                <div className="flex gap-2">
                                    <button onClick={() => {
                                        setEditingId(p.id);
                                        setEditText(p.text);
                                    }} className="text-blue-600">
                                        <PencilIcon className="h-5 w-5"/>
                                    </button>
                                    <button onClick={() => handleDelete(p.id)} className="text-red-600">
                                        <TrashIcon className="h-5 w-5"/>
                                    </button>
                                </div>
                            </>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SpoiledPhrasesManager;